import { useRillContext } from "../rill/RillReact/share/base";
import LoginWrapper from "./LoginWrapper";
import { useTranslation } from "react-i18next";

function View() {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const {
    params: { token },
  } = locals;
  return (
    <LoginWrapper
      left={
        <form method="POST" action="/actions/user/update-password" data-noreset>
          <div>
            <h1>{t("updatePassword.title")}</h1>
          </div>
          <input type="hidden" name="token" value={token} />
          <label htmlFor="password">{t("updatePassword.passwordLabel")}</label>
          <input
            className="text-input"
            type="password"
            name="password"
            placeholder={t("updatePassword.passwordPlaceholder")}
            required
          />
          <label className="mt-4" htmlFor="confirmPassword">
            {t("updatePassword.confirmPasswordLabel")}
          </label>
          <input
            className="text-input"
            type="password"
            name="confirmPassword"
            placeholder={t("updatePassword.confirmPasswordPlaceholder")}
            required
          />
          <button data-button-type="primary" sz="large" type="submit">
            {t("updatePassword.submit")}
          </button>
        </form>
      }
    />
  );
}

const UpdatePassword = (app) => {
  app.get(
    "/update-password/:token",
    ({ isLoggedIn, logout, session }, next) => {
      if (isLoggedIn()) {
        logout();
        session.clear();
      }
      return next();
    },
    ({ res }) => {
      res.body = <View />;
    }
  );
};

export default UpdatePassword;
